<template>
  <div id="app" :class="{ loaded: isLoaded }">
    <router-view />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const isLoaded = ref(false)

onMounted(() => {
  isLoaded.value = true
})
</script>

<style>
/* Global app styles handled in style.css */
</style>
